export default __webpack_public_path__ + "static/media/07.cd9feac8.jpeg";